import React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';

import { useProducts } from 'lib/hooks/queries/products/useProducts';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import Allowed from 'components/shared/Permissions/Allowed';

import ProductModal from './components/ProductModal';
import { defaultColumns, defaultFilters } from './lib/helpers';

const Products = () => {
  return (
    <Allowed requiredPermissions="products.read" showIllustration={true} showMessage={true}>
      <AgTablePage
        ModalComponent={ProductModal}
        defaultColumns={defaultColumns}
        defaultFilters={defaultFilters}
        useData={useProducts}
        name="products"
      />
    </Allowed>
  );
};

export default Products;
